import { useIntl } from "react-intl";
import Pacman from "src/app/components/layout/Pacman";
import { useLastOrderWithModifyImage } from "src/app/hooks";

const AfterAndBeforeImageGridContainer = () => {
    const { orders, loading } = useLastOrderWithModifyImage();
    const { formatMessage } = useIntl();
    if (loading) return <Pacman />;
    return (
        <div className="afterAndBeforeImageGridContainer">
            {orders.map((el, index) => (
                <div className="cardWrapper" key={index}>
                    <div className="card">
                        <div className="images">
                            {el.content?.images && (
                                <div className="imageWrapper">
                                    <a href={el.content?.images[0]?.largeImageUrl} target="_blank">
                                        <img src={el.content?.images[0]?.largeImageUrl} />
                                    </a>
                                </div>
                            )}

                            <div className="imageWrapper">
                                <a
                                    href={`https://s3.eu-west-1.amazonaws.com/files.digitent.co/images/${el?.id}_0.webp`}
                                    target="_blank"
                                >
                                    <img
                                        src={`https://s3.eu-west-1.amazonaws.com/files.digitent.co/images/${el?.id}_0.webp`}
                                    />
                                </a>
                            </div>
                        </div>

                        <div className="information">
                            <span>
                                <b>{formatMessage({ id: "common.field.moneySite" })} : </b>
                                {el.moneySite?.domain}
                            </span>
                            <span>
                                <b>{formatMessage({ id: "common.field.platform" })} : </b>
                                {el.platform?.name || "none"}
                            </span>
                            <span>
                                <b>{formatMessage({ id: "common.field.rd" })} : </b>
                                {el.rd?.domain}
                            </span>
                            <span>
                                <b>{formatMessage({ id: "common.field.title" })} : </b>
                                {el.content?.title}
                            </span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
export default AfterAndBeforeImageGridContainer;
